module.exports = __webpack_public_path__ + "static/media/sf-test-6.0328e3de.mp3";